export class PetDiagnosisModel {
    pet_no: number
    old_diagnosis: string
    new_diagnosis: string
    modified_date: string
    modified_by: number

    constructor(
        pet_no: number,
        old_diagnosis: string,
        new_diagnosis: string,
        modified_date: string,
        modified_by: number
    ) {
        this.pet_no = pet_no
        this.old_diagnosis = old_diagnosis
        this.new_diagnosis = new_diagnosis
        this.modified_date = modified_date
        this.modified_by = modified_by
    }
}